export const MAX_TAGS_AMOUNT = 1000;
export const MAX_BANKS = 1000;

// for paging
export const defaultPerPage = {label: 20, value: 20}
export const defaultPerPageOptions = [
  {label: 20, value: 20},
  {label: 50, value: 50},
  {label: 100, value: 100},
  {label: "全て", value: 1000}
]

export const defaultAccountStatus = {label: "全て", value: {}}
export const defaultAccountStatusOpts = [
  {label: "全て", value: {}},
  {label: "取得成功", value: {error: {id: [0]}, is_suspended: false, last_succeeded_at: '!_null'}},
  {label: "エラー", value: [{error: {id: [1, 2, 3, 4, 5, 6, 7, 8, 9]}}, { error: {id: 0}, last_succeeded_at: null, is_suspended: false }]},
  {label: "停止中", value: {is_suspended: true}},
]

export const defaultOrderAccount = {label: "名前順", value: {attr: 'display_name', direction: 'asc'}}
export const defaultOrderAccountOpts = [
  {label: "名前順", value: {attr: 'display_name', direction: 'asc'}},
  {label: "更新順", value: {attr: 'last_aggregated_at', direction: 'desc'}},
  {label: "登録が新しい順", value: {attr: 'created_at', direction: 'desc'}}
]
